import {
    getTestStory,
    regressionTest,
} from "../../../../../test-utils/regression";

describe("ux-text-headline", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("text", "headlines"),
        });
    });
});
